import axios from "axios";
import env from "../env";
import customConfig from "../config";
import { notificationTaskListPageSize } from "../components/notificationManagement/notificationConstant";

const TASKS_PATH = "/simplifi/v1/notificationmanager/task";

const jsonConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

const tasksUrl = () => `${env.GET_DEVICEMANAGEMENT_API_URL()}${TASKS_PATH}`;

const getErrorMessage = (error, fallback) => {
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.request) return customConfig.NETWORK_ERROR;
  return error?.message || fallback || customConfig.SOMETHING_WENT_WRONG;
};

const compactParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

const parseTaskList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.tasks)) return data.tasks;
  if (Array.isArray(data?.data)) return data.data;
  if (data?.taskId) return [data];
  return [];
};

export const notificationTaskListService = {
  async listRecentTasks({
    pageIndex = 1,
    pageSize = notificationTaskListPageSize,
    taskId,
    userId,
  } = {}) {
    const size = Number(pageSize) > 0 ? Number(pageSize) : notificationTaskListPageSize;
    const uiPage = Number(pageIndex) > 0 ? Number(pageIndex) : 1;
    const pgIndex = uiPage - 1;

    try {
      const response = await axios.get(tasksUrl(), {
        ...jsonConfig,
        params: compactParams({
          pgIndex,
          pgSize: size,
          taskId,
          userId,
        }),
      });
      const data = parseTaskList(response?.data);
      return {
        success: true,
        data,
        pageIndex: uiPage,
        pageSize: size,
        isLastPage: data.length < size,
      };
    } catch (error) {
      return {
        success: false,
        data: [],
        pageIndex: uiPage,
        pageSize: size,
        isLastPage: true,
        message: getErrorMessage(error, customConfig.FETCH_FAILURE),
      };
    }
  },
};
